import type { FieldComponents } from '@/shared/components/form-fields/types';
import { CircleCheck, CircleX } from 'lucide-react';
import { withForm } from '../../hooks/use-proposal-decision-form.hook';
import { DecisionAcceptFields } from './decision-accept-fields.component';
import { decisionFormOpts } from './decision-form-options';
import { DecisionRejectFields } from './decision-reject-fields.component';

const buildDecisionOptions = (goesToInspection: boolean) => [
  {
    label: 'Aceitar Proposta',
    value: 'ACCEPT',
    icon: <CircleCheck className='size-6' />,
    description: goesToInspection ? 'Segue para Inspeção.' : 'Segue para Emissão.',
  },
  {
    label: 'Recusar Proposta',
    value: 'REJECT',
    icon: <CircleX className='size-6' />,
    description: 'Motivo será enviado.',
  },
];

export const DecisionFormBody = withForm({
  ...decisionFormOpts,
  props: {} as { requiresInspection?: string },
  render: ({ form, requiresInspection }) => (
    <div className='flex flex-col gap-y-4'>
      <form.AppField
        name='status'
        validators={{
          // Sem anotar o parâmetro: este form É tipado (ProposalDecisionValues),
          // então o TanStack infere `value` — anotar conflita com a assinatura
          // real, que também recebe `fieldApi`.
          onChange: ({ value }) => {
            if (!value) return 'A decisão é obrigatória';
            return undefined;
          },
          onSubmit: ({ value }) => {
            if (!value) return 'A decisão é obrigatória';
            return undefined;
          },
        }}
        children={(field: FieldComponents) => (
          <field.RadioCardField
            required
            options={buildDecisionOptions(requiresInspection === 'S')}
          />
        )}
      />

      <form.Subscribe
        selector={(state: {
          values: { status: null | 'ACCEPT' | 'REJECT' };
        }) => ({
          status: state.values.status,
        })}
        children={({ status }: { status: null | 'ACCEPT' | 'REJECT' }) => {
          if (status === 'ACCEPT') return <DecisionAcceptFields form={form} />;
          if (status === 'REJECT') return <DecisionRejectFields form={form} />;
          return null;
        }}
      />
    </div>
  ),
});
